import { render } from "./NavBarAksi.vue?vue&type=template&id=5618c964"
import script from "./NavBarAksi.vue?vue&type=script&lang=js"
export * from "./NavBarAksi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__